import * as React from 'react';
import { List, Avatar, Row, Col, Card, Button, Divider } from 'antd';
import OfferingCard from '../OfferingCard';
import { OfferingStatus, SlimOffering } from 'Core/Api/Api';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import DetailsMode from '../../../../Core/models/DetailsMode';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { BrandedLink } from '../../../Styled/Branded/BrandedLink';
import { startCase } from 'lodash';
import { OfferingCardClasses } from '../../../Dashboard/DashboardView/DashboardView.Style';
import { GeneralApplyNowLink } from '../../OfferingDetailsView';
import IfNotLoggedInModal from '../../../Forms/IfNotLoggedInModal';
import DetailsData from '../../../../Core/models/DetailsData';
import AuthContext from '../../../../Context/AuthContext';

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
    offerings?: SlimOffering[];
}

export interface State { }

export default class OfferingCardList extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props);

        this.state = {};
    }


    generalApplyClicked(id: string | undefined) {
        if (id) {
            if (this.context.data) {
                this.props.history.push(
                    `/ipo/apply/${id}`,
                    new DetailsData(DetailsMode.New, id)
                );
            } else {
            }
        }
    };

    render() {
        return (
            <div>
                { true ?
                    <>
                        <Row gutter={16} type={'flex'}>
                            {
                                this.props.offerings?.map(item => {
                                    return <Col xs={24} xl={12} xxl={8} style={{ marginBottom: '10px' }}>
                                        <Card style={{ backgroundColor: 'white' }}

                                            actions={[
                                                <Row style={{ padding: '15px' }} gutter={16}>
                                                    <Col xs={12} style={{ textAlign: 'right' }}>
                                                        {item.status == OfferingStatus.PreOpen || item.status == OfferingStatus.Opened ?
                                                            <IfNotLoggedInModal>
                                                                <GeneralApplyNowLink onClick={this.generalApplyClicked.bind(this, item.id)}>
                                                                    <span style={{ fontWeight: 'bold' }}>Apply Now</span>
                                                                </GeneralApplyNowLink>
                                                            </IfNotLoggedInModal>
                                                            : <GeneralApplyNowLink disabled>
                                                                <span style={{ fontWeight: 'bold' }}>Apply Now</span>
                                                            </GeneralApplyNowLink>
                                                        }
                                                    </Col>
                                                    <Col xs={12} >
                                                        <BrandedLink style={{}}
                                                            to={{
                                                                pathname: 'ipo/details/' + encodeURI(item.id ?? ''),
                                                                state: { ipoId: item.id, mode: DetailsMode.New }
                                                            }}>
                                                            <Button style={{ color: '#F0403D', borderColor: '#F0403D', width: '100%', fontWeight: 'bold' }} ghost>View Details</Button>

                                                        </BrandedLink>
                                                    </Col>
                                                </Row>
                                            ]}
                                            title={<Row>
                                                <Col span={24}>
                                                    {item.title}
                                                </Col>
                                            </Row>} >
                                            <OfferingCardClasses>
                                                <Row>
                                                    <Col xs={24} sm={12} xl={10}>
                                                        <div className="center-avatar">
                                                            <Avatar src={item.fileUrl} size={128} shape="square" />
                                                        </div>
                                                    </Col>
                                                    <Col xs={24} md={12} xl={14}>
                                                        <Row><Col><b>Status: </b><span className={'offering-status ' + item.status} style={{ float: 'right' }}>  {startCase(item.status)}</span></Col></Row>
                                                        <Divider />
                                                        <Row><Col><b>Currency: </b><span style={{ float: 'right' }}> {item.currency}</span></Col></Row>
                                                        <div><Row><Col><b>General Share Unit Price: </b> <NumberFormat style={{ float: 'right' }} value={item.generalSharePrice} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} /> </Col></Row>
                                                            <Row><Col><b>General Share Amount: </b>  <NumberFormat style={{ float: 'right' }} value={item.generalShareAmount} displayType={'text'} thousandSeparator={true} /> </Col></Row>
                                                            <Row><Col><b>Opening Date: </b><span style={{ float: 'right' }}>  {moment(item.openingDate)?.format('MMMM D YYYY')}</span></Col></Row>
                                                            <Row><Col><b>Closing Date: </b><span style={{ float: 'right' }}>  {moment(item.closingDate)?.format('MMMM D YYYY')}</span></Col></Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </OfferingCardClasses>
                                        </Card>
                                    </Col>
                                })
                            }
                        </Row>
                    </> :
                    <List
                        grid={{ gutter: 16, lg: 2, xxl: 3 }}
                        dataSource={this.props.offerings}
                        renderItem={item => (
                            <List.Item>
                                <Card style={{ backgroundColor: 'white' }} title={<Row>
                                    <Col span={12}>
                                        {item.title}
                                    </Col>
                                    <Col span={12} style={{ textAlign: 'right' }}>
                                        <BrandedLink
                                            to={{
                                                pathname: 'ipo/details/' + encodeURI(item.id ?? ''),
                                                state: { ipoId: item.id, mode: DetailsMode.New }
                                            }}>
                                            More Details
                                </BrandedLink>
                                    </Col>
                                </Row>} >
                                    <Row>
                                        <Col span={12}>
                                            <Avatar src={item.fileUrl} size={128} shape="square" />
                                        </Col>
                                        <Col span={12}>
                                            <div><Row><Col><b>General Share Unit Price:</b> <NumberFormat style={{ float: 'right' }} value={item.generalSharePrice} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} /> </Col></Row>
                                                <Row><Col><b>General Share Amount: </b> <NumberFormat style={{ float: 'right' }} value={item.generalShareAmount} displayType={'text'} thousandSeparator={true} /> </Col></Row>
                                                <Row><Col><b>Currency: </b> <span style={{ float: 'right' }}> {item.currency}</span></Col></Row>
                                                <Row><Col><b>Opening Date: </b><span style={{ float: 'right' }}>  {moment(item.openingDate)?.format('MMMM D YYYY')}</span></Col></Row>
                                                <Row><Col><b>Closing Date: </b><span style={{ float: 'right' }}>  {moment(item.closingDate)?.format('MMMM D YYYY')}</span></Col></Row>
                                                <Row><Col><b>Status: </b><span style={{ float: 'right' }}>  {startCase(item.status)}</span></Col></Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </List.Item>

                        )}
                    />
                }
            </div>
        );
    }
}
